// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a91a43ed","703":"bf39c762","787":"a7fe0d79"}[chunkId] + ".chunk.js";
};